import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface FlowDiscount {
  flowId: string;
  discountCode: string;
}
interface IDiscountStore {
  discountCodes: FlowDiscount[];
  _hasHydrated: boolean;
  setHasHydrated(state: boolean): void;
  setDiscountCode(flowId: string, newDiscountCode: string | undefined): void;
  clearDiscountCode(flowId: string): void;
}

export const useDiscountStore = create<IDiscountStore>()(persist((set) => ({
  discountCodes: [],
  _hasHydrated: false,
  setHasHydrated: (state: boolean) => {
    set({ _hasHydrated: state });
  },
  setDiscountCode: (flowId: string, newDiscountCode: string | undefined) => set((state) => {

    if (!newDiscountCode?.trim()) {
      return state;
    }
    if (state.discountCodes.find((dc) => dc.flowId === flowId)) {
      return ({
        discountCodes: state.discountCodes
          .map((dc) => (dc.flowId === flowId ? ({ ...dc, discountCode: newDiscountCode }) : dc)),
      });
    }
    return {
      discountCodes: [ ...state.discountCodes, { flowId, discountCode: newDiscountCode } ],
    };
  }),
  clearDiscountCode: (flowId: string) => set((state) => ({
    discountCodes: state.discountCodes.filter((dc) => dc.flowId !== flowId),
  })),
}), {
  name: "discount-store",
  onRehydrateStorage: () => (state) => {
    state?.setHasHydrated(true);
  },
}));

export default useDiscountStore;
